import { render, staticRenderFns } from "./ContactoHomeComp.vue?vue&type=template&id=28b30f3d&scoped=true&"
import script from "./ContactoHomeComp.vue?vue&type=script&lang=js&"
export * from "./ContactoHomeComp.vue?vue&type=script&lang=js&"
import style0 from "./ContactoHomeComp.vue?vue&type=style&index=0&id=28b30f3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b30f3d",
  null
  
)

export default component.exports